import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { enrollmentQuery } from "@/lib/family";

export const Route = createFileRoute("/_app/checkout/success")({
  validateSearch: (search: Record<string, unknown>) => ({
    enrollment_id: typeof search.enrollment_id === "string" ? search.enrollment_id : "",
  }),
  component: CheckoutSuccess,
});

// Stripe sends the parent here after checkout; the webhook marks the enrollment a moment later,
// so poll until it shows as paid (card) or processing (bank).
function CheckoutSuccess() {
  const { enrollment_id } = Route.useSearch();
  const { data: enrollment } = useQuery({
    ...enrollmentQuery(enrollment_id),
    enabled: !!enrollment_id,
    refetchInterval: (q) => {
      const e = q.state.data;
      return e && (e.status === "paid" || e.payment_submitted_at) ? false : 2000;
    },
  });

  const paid = enrollment?.status === "paid";
  const processing = !paid && !!enrollment?.payment_submitted_at;

  return (
    <section className="mx-auto max-w-lg text-center">
      <h1 className="font-display text-4xl font-extrabold uppercase italic">
        {paid ? "You're registered!" : processing ? "Payment submitted" : "Confirming payment…"}
      </h1>
      <p className="mt-4 text-white/70">
        {paid
          ? "Thank you. We emailed you a receipt."
          : processing
            ? "Bank payments take a few business days to clear. We'll email your receipt as soon as it does."
            : "This usually takes a few seconds."}
      </p>
      <Link
        to="/home"
        className="mt-8 inline-block rounded-md bg-a1-red px-5 py-2.5 text-sm font-semibold text-white hover:bg-a1-red/90"
      >
        Back to home
      </Link>
    </section>
  );
}
